import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AvatarDirective } from './avatar.directive';
import {
  DualAvatarComponent,
  AvatarPrimaryDirective,
  AvatarSecondaryDirective,
} from './dual-avatar.component';
import { AvatarComponent } from './avatar.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    AvatarDirective,
    DualAvatarComponent,
    AvatarPrimaryDirective,
    AvatarSecondaryDirective,
    AvatarComponent,
  ],
  exports: [
    AvatarDirective,
    DualAvatarComponent,
    AvatarPrimaryDirective,
    AvatarSecondaryDirective,
    AvatarComponent,
  ],
})
export class AvatarModule {}
